import Main from './components/Main.vue'
import Info from './components/Info.vue'
import Password from './components/ChangePassword.vue'
import Preferences from './components/Preferences.vue'

export default [
    {
        name: 'profile.index',
        path: '/profile',
        redirect: '/profile/info',
        component: Main,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                name: 'profile.info',
                path: '/profile/info',
                component: Info,
                meta: { requiresAuth: true }
            },
            {
                name: 'profile.password',
                path: '/profile/password',
                component: Password,
                meta: { requiresAuth: true }
            },
            {
                name: 'profile.preferences',
                path: '/profile/preferences',
                component: Preferences,
                meta: { requiresAuth: true }
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/modules/profile/routes.js